import { Switch } from '@headlessui/react'
import PropTypes from 'prop-types'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export const MySwitch = ({
  label,
  onChange,
  value,
  utilityLabel,
  utilityContainer,
  utilityContainerGeneral,
  isDisabled,
  name,
  customFunc,
}) => {
  return (
    <div className={utilityContainerGeneral} onClick={customFunc}>
      {!!label && (
        <label className={`block ${utilityLabel} text-slate-700`}>
          {label}
        </label>
      )}
      <div className={utilityContainer}>
        <Switch
          checked={value}
          className={classNames(
            value ? 'bg-orange-500' : 'bg-slate-200',
            'relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent ' +
              'transition-colors duration-200 ease-in-out focus:outline-none' +
              'focus:ring-2 focus:ring-orange-500 focus:ring-offset-2'
          )}
          disabled={isDisabled}
          name={name}
          onChange={onChange}
        >
          <span
            className={classNames(
              value ? 'translate-x-5' : 'translate-x-0',
              'pointer-events-none relative inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 ' +
                'transition duration-200 ease-in-out'
            )}
          >
            <span
              aria-hidden="true"
              className={classNames(
                value
                  ? 'opacity-0 duration-100 ease-out'
                  : 'opacity-100 duration-200 ease-in',
                'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
              )}
            >
              <svg
                className="h-3 w-3 text-slate-400"
                fill="none"
                viewBox="0 0 12 12"
              >
                <path
                  d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                />
              </svg>
            </span>
            <span
              aria-hidden="true"
              className={classNames(
                value
                  ? 'opacity-100 duration-200 ease-in'
                  : 'opacity-0 duration-100 ease-out',
                'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity'
              )}
            >
              <svg
                className="h-3 w-3 text-orange-600"
                fill="currentColor"
                viewBox="0 0 12 12"
              >
                <path
                  d={
                    'M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5' +
                    ' 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414' +
                    ' 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z'
                  }
                />
              </svg>
            </span>
          </span>
        </Switch>
      </div>
    </div>
  )
}
export default MySwitch

MySwitch.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onChange: PropTypes.func,
  value: PropTypes.bool,
  utilityLabel: PropTypes.string,
  utilityContainer: PropTypes.string,
  utilityContainerGeneral: PropTypes.string,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  customFunc: PropTypes.func,
}
